import { call, select, take } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import { featureFlagsSelectors } from '../feature-flags';
import * as actions from './investmentQuotesV2Actions';
import { getLastSyncDate } from './investmentQuotesV2Selectors';
import { mkInvestmentQuoteV2 } from './investmentQuotesV2Types';

export function* getInvestmentQuotesActionWatcher() {
  while (true) {
    const action = yield take(actions.getInvestmentQuotesV2);
    const featureFlag = yield select(featureFlagsSelectors.getFeatureFlag, 'realTimeQuotes');
    const config = resourceStoreTypes.mkQcsSyncResourceConfig({
      resourceName: 'investment quotes',
      resourceBaseUrl: '/v2/investments/quotes',
      axiosConfig: {
        params: {
          realTime: featureFlag,
        },
      },
      getLastSyncDate,
      successAction: actions.getInvestmentQuotesV2Success,
      failureAction: actions.getInvestmentQuotesV2Failure,
      transformResponseToResources: (response) =>
        response.data &&
        response.data.resources &&
        response.data.resources.map((data) =>
          mkInvestmentQuoteV2({
            ...data,
            id: data.symbol,
          }),
        ),
    });

    yield call(resourceSagaUtils.qcsSyncGetResources, config, action);
  }
}

export default [getInvestmentQuotesActionWatcher];
